export { default as publicRoutes } from '~/src/server/routes/public.js'
export { default as dummyApiRoutes } from '~/src/server/routes/dummy-api.js'
